<panel>
	<h1>{{'taskflow-template.list-taskflow-templates' | translate}}</h1>
	<list-view [emptyLabel]="'taskflow-template.taskflow-template-list-empty-label'">
		<header defaultSort="ascending">{{ 'general.name' | translate }}</header>
		<header>{{ 'general.created' | translate }}</header>
		<header></header>
		<row *listData="let template from taskflowTemplates" [highlighted]="selectedTaskflowTemplateId == template.id" (action)="editTaskflow(template.id)">
			<column>{{ template.title }}</column>
			<column>{{ template.created | customDate: 'shortDate' }}</column>
			<column align-right><icon (click)="deleteTaskflowTemplates(template.id)" type="trash-alt" /></column>
		</row>
	</list-view>
	<section>
		<button [loader]="false" (click)="createTaskflow()">{{'taskflow-template.create-taskflow-template' | translate}}</button>
	</section>
</panel>
